<template>
  <div :class="getCss('wrap')" :style="{...styles.base,...bgImageStyle}" ref="video">
    <!--    弹框播放       -->
    <div
      :class="getCss('video-container')"
      ref="videoContainerMask"
      v-transfer-dom
      v-show="isShowVideoPlay"
    >
      <div ref="popVideo" :style="popVideoStyle" :class="getCss('video-content')"></div>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import '@tencent/ceiba-act-sdk-player';
export default {
  name: 'CVideo',
  components: {
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'video-',
      isShowVideoPlay: false,
      prePlayBgImg: '',
      ZIndex: 0,
    };
  },
  computed: {
    // 1  默认播放
    // 2  弹框播放
    playType() {
      return this.configurationData.playType || 0;
    },
    popVideoStyle() {
      const { popPlayContainerWidth = 750, popPlayContainerHeight = 480 } = this.configurationData;
      const style = { width: `${popPlayContainerWidth || 750}px`, height: `${popPlayContainerHeight || 480}px` };
      if (this.deviceMode === 'pc') {
        return style;
      }
      return common.tool.transformStyle(style);
    },
    bgImageStyle() {
      const { prePlayBgImg } = this;
      const { bgDisplayType = 1 } = this.configurationData;
      // bgDisplayType  === 1 图片大小缩放
      // bgDisplayType  === 2 区域大小缩放
      return {
        backgroundImage: prePlayBgImg ? `url('${prePlayBgImg}')` : 'none',
        backgroundSize: bgDisplayType === 1 ? '100% 100%' : 'contain',
        backgroundRepeat: 'no-repeat',
        zIndex: this.ZIndex > 0 ? this.ZIndex : this.styles.base['z-index'],
      };
    },
    muted() {
      const { prePlayBgImg, autoPlay = true } = this.configurationData;
      return !prePlayBgImg && autoPlay === true;
    },
    enable() {
      const { playVideoCallBackFlowId = 0 } = this.configurationData;

      const packageStatus = this.quaInfo[playVideoCallBackFlowId];
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
  },
  watch: {
    'configurationData.prePlayBgImg': {
      handler(newVal) {
        this.prePlayBgImg = newVal;
      },
      immediate: true,
    },
  },
  mounted() {
    console.log('configurationData= video 1.0.5 ', this.configurationData);
    this.prePlayBgImg = this.configurationData.prePlayBgImg;
    if (this.$isInEditor) return;
    const { prePlayBgImg, playType = 1 } = this.configurationData;
    // 没有填写背景图 统一 默认不弹框播放
    const that = this;
    this.domId = this.setId();
    if (!prePlayBgImg) {
      this.playTouchVideo();
      return;
    }
    //  有填写背景图 不弹框播放的
    if (playType === 1) {
      this.$nextTick(function () {
        const container = this.$refs.video;
        container.addEventListener('click', this.handleFunc, false);
      });

      return;
    }
    //   有填写背景图 弹框播放的
    if (playType === 2) {
      this.domId = this.setId(this.$refs.popVideo);
      this.$nextTick(() => {
        const container = this.$refs.video;
        const handleFunc = (event) => {
          event && event.stopPropagation();
          if (that.isShowVideoPlay === false) {
            that.isShowVideoPlay = true;
            that.playTouchVideo({});
          }
        };
        container.addEventListener('click', handleFunc, false);
        this.$refs.videoContainerMask.addEventListener(
          'click',
          (event) => {
            event && event.stopPropagation();
            if (
              event.target.attributes.class
              && event.target.attributes.class.nodeValue === 'csu-video-video-container'
            ) {
              that.pauseVideo();
              that.isShowVideoPlay = false;
            }
          },
          false,
        );
      });
      return;
    }
  },
  methods: {
    handleFunc() {
      const container = this.$refs.video;
      container.removeEventListener('click', this.handleFunc);
      this.playTouchVideo({});
      this.resetBg();
    },
    getContainer() {
      return this.playType === 1 || !this.prePlayBgImg ? this.$refs.video : this.$refs.popVideo;
    },

    setId(container) {
      // eslint-disable-next-line no-param-reassign
      container = container || this.getContainer();
      let domId = container.id;
      if (!domId) {
        domId = this.getRandomId('videos');
        container.setAttribute('id', domId);
      }
      return domId;
    },
    getRandomId(prefix) {
      return `${prefix}${Math.random().toString(36)
        .slice(-10)}`;
    },
    pauseVideo() {
      const k = this.getVideoInstanceMakeKey();
      window[k] && window[k].pause();
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'play_video',
        eventData: {
          status: '0',
          vid: this.configurationData.vid,
        },
      });
    },
    getVideoInstanceMakeKey() {
      return `video-instance-${this.domId}`;
    },
    playTouchVideo(option = {}) {
      // 参数说明 http://m.v.qq.com/txp/v3/src/jsapi/params.html
      const playConfig = {
        containerId: this.domId,
        width: '100%',
        vid: this.configurationData.vid,
        height: '100%',
        hideHD: true,
        volume: 50,
        autoplay: this.configurationData.autoPlay,
        // 如果设置自动播放 需初始化静音
        muted: this.muted,
        // poster: 'http://img.xinyue.qq.com/1141/视频背景图.png',
        ...option,
      };
      console.log('_-----------init----playConfig', playConfig);
      const k = this.getVideoInstanceMakeKey();
      if (!window[k]) {
        window[k] = new window.Txplayer(playConfig);
      } else {
        window[k].seekTo(0);
      }
      // 如何不是弹框播放 需要修改层叠
      const { prePlayBgImg, playType = 1 } = this.configurationData;

      if (!prePlayBgImg || playType === 1) {
        const instance = window[k];
        const that = this;
        instance.on('browserFullscreenChange', (res) => {
          console.log('access browserFullscreenChange playVideo', res);
          that.ZIndex = res ?  1000 : 0;
        });
      }

      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'play_video',
        eventData: {
          status: '1',
          vid: this.configurationData.vid,
        },
      });
      this.playVideoCallBack();
    },
    resetBg() {
      this.prePlayBgImg = '';
    },
    async playVideoCallBack() {
      const { playVideoCallBackFlowId = 0, playVideoCallBackMsg = '' } = this.configurationData;
      if (playVideoCallBackFlowId > 0) {
        if (!this.enable) {
          console.log('playVideoCallBack has access ');
          return false;
        }
        const response = await this.flowRequest({
          flowId: playVideoCallBackFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('response playVideos CallBack  =', response);
        const { ret: rspRet = 0, data = {} } = response;
        const { ret: ResRet = 0 } = data;
        if (rspRet === 0 && ResRet === 0) {
          if  (playVideoCallBackMsg) {
            this.$alert({ msg: playVideoCallBackMsg });
          }
          this.refreshQua(); // 刷新礼包
          return true;
        }
        return  false;
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
